import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'

const OrganizeGraphic = () => {
  const data = useStaticQuery(graphql`
    query {
      organizeGraphicImage: file(relativePath: { eq: "graphics/organize-graphic.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <Img
      fluid={data.organizeGraphicImage.childImageSharp.fluid}
      alt="Organize Graphic"
    />
  )
}

export default OrganizeGraphic
